/* eslint-disable no-restricted-globals */
import { FC } from "react";

import styled from "styled-components";

const YandexLogo = require("../assets/Yandex_icon.png");

interface ILoginButtonProps {
  disabled?: boolean | string;
}

export const LoginButton: FC<ILoginButtonProps> = ({ disabled }) => {
  const redirect =
    window.location.protocol + "//" + window.location.host + "/login";
  return (
    <YandexButton
      className={disabled ? "disabled" : ""}
      href={`https://oauth.yandex.ru/authorize?${new URLSearchParams({
        response_type: "token",
        client_id: "5566cc74b9f04ffc9d1aa2a05664c0f8",
        redirect_uri: redirect,
      })}`}
    >
      <img src={YandexLogo} alt="logo" />
      <button>Войти с Яндекс ID</button>
    </YandexButton>
  );
};

const YandexButton = styled.a`
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  padding: 10px;
  width: 260px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
  background: #000;
  color: white;

  button {
    cursor: pointer;
    border: none;
    background: transparent;
    color: white;
  }

  img {
    width: 24px;
    height: 24px;
  }

  :hover {
    background: #121111;
  }

  &.disabled {
    pointer-events: none;
    cursor: default;
  }
`;
